import useYearlyReports from "@hooks/HRM/reports/useYearlyReports";
import YearlyReportsPageHeader from "./components/YearlyReportsPageHeader";
import { YearlyReports } from "./components";

export default function YearlyReportsPage() {
  const {
    downloadReport,
    selectedReport,
    isLoading,
    handleQuery,
    reportData,
    selectedData,
    date,
  } = useYearlyReports();
  return (
    <div className="p-10">
      <YearlyReportsPageHeader
        downloadReport={downloadReport}
        selectedReport={selectedReport}
        isLoading={isLoading}
      />
      <YearlyReports
        date={date}
        handleQuery={handleQuery}
        reportData={reportData}
        selectedReport={selectedReport}
        selectedData={selectedData}
      />
    </div>
  );
}
